// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".group-grid[data-v-63b6c344]{display:grid;grid-template-columns:4rem 8.1% 7.6% 12% 10.3% 14.6% 15.9% 17.7%;grid-column-gap:1.5rem}", ""]);
// Exports
module.exports = exports;
